// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Fcu7c","top":"styles_top__28bhP"};